<template>
  <v-dialog max-width="400" v-model="isMeetingDeleteDialog" @click:outside="close">
    <!-- <template v-slot:activator="{ on, attrs }">
      <v-btn
        width="80"
        v-if="isMtOrganizer"
        color="#43535e"
        class="white1--text d-none d-md-flex"
        style="margin-left: 15px"
        v-bind="attrs"
        v-on="on"
      >
        {{ $t('delete') }}
      </v-btn>
    </template> -->
    <v-card class="container-meeting-delete px-5 py-3" color="#21343b" width="auto">
      <v-row no-gutters align="center" justify="center">
        <v-col class="px-5 mt-2" :cols="12" align="start" justify="start">
          <span class="delete-meeting-title">{{ $t('deleteMeeting') }}</span>
        </v-col>
        <v-col class="px-5 mt-2" :cols="12" align="start" justify="center">
          <span class="delete-meeting-content">{{ $t('deleteMeetingContent') }}</span>
        </v-col>
        <v-row class="d-flex flex-nowrap container-btn my-4 mx-5" no-gutters align="start" justify="center">
          <v-btn
            :loading="isDeleteMtLoading"
            width="120"
            height="40"
            elevation="0"
            color="#ff575f"
            @click="meetingDelete"
            class="mr-5"
          >
            {{ $t('delete') }}
          </v-btn>
          <v-btn width="120" height="40" elevation="0" color="#869399" @click="close">
            {{ $t('cancel') }}
          </v-btn>
        </v-row>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { deleteMeeting } from '@/services/meetingApi'
import Toast from '@/views/meeting/component/Toast'
import { isMobile } from '@/common/lib/strLib'
import { mapGetters } from 'vuex'

export default {
  name: 'MeetingDeleteDialog',
  props: {
    isMeetingDeleteDialog: Boolean,
    mtId: String,
  },
  data() {
    return {
      isDeleteMtLoading: false,
    }
  },
  methods: {
    // Meeting 삭제
    async meetingDelete() {
      try {
        this.isDeleteMtLoading = true
        // await this.$store.dispatch('setIsLoading', true)
        await deleteMeeting(
          this,
          'MEETING',
          this.selectedCh && this.selectedCh['wsId'] ? this.selectedCh['wsId'] : this.selectedWsInfo.wsId,
          this.mtId
        )
        // notify(this, 'Success', this.$t('deleteMeetingSuccess'), 'success')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('deleteMeetingSuccess'),
            // submsg: '',
          },
        }
        this.$toast.success(content)

        // 미팅이 삭제되었을 시 workspace 의 총 클립 갯수를 새롭게 업데이트 시켜준다.
        this.$store.dispatch('setWsClipCnt', {
          wsDomain: this.$route.params['wsDomain'],
          userId: this.userInfo ? this.userInfo['userId'] : null,
        })
        this.isDeleteMtLoading = false
        // await this.$store.dispatch('setIsLoading', false)
        this.$emit('result', this.mtId)
        this.close()
        let routerName = ''
        if (this.$route.name.indexOf('Inbox') > -1) routerName = 'Inbox'
        else if (this.$route.name.indexOf('Assigned') > -1) routerName = 'Assigned'
        else routerName = 'Channel'
        this.$router
          .replace({
            name: routerName,
            params: {
              wsDomain: this.$route.params['wsDomain'] ?? this.selectedWsInfo['wsDomain'],
              chId: this.selectedCh && this.selectedCh['chId'] ? this.selectedCh['chId'].replace('CH:', '') : 'my',
            },
          })
          .catch(() => {})
        // if (this.$route.name.indexOf('Inbox') === -1)
        //   this.$store.dispatch('setSelectedCh', {
        //     chType: this.selectedCh['chType'],
        //     chId: this.selectedCh['chId'].replace('CH:', ''),
        //     chIntegrationInfo: this.selectedCh['chIntegrationInfo'],
        //   })
      } catch (error) {
        // notify(this, 'Error', this.$t('general.error'), 'error')
        const content = {
          component: Toast,
          props: {
            msg: this.$t('general.error'),
            // submsg: '',
          },
        }
        this.$toast.error(content)
        console.log(error)
      }
    },
    close() {
      this.$emit('close', 'Delete')
    },
  },
  computed: {
    ...mapGetters(['selectedWsInfo', 'selectedCh', 'userInfo']),
    isMobile() {
      return isMobile()
    },
  },
}
</script>

<style scoped>
.v-dialog__content >>> .v-dialog {
  overflow: hidden;
}
.container-meeting-delete {
  border-radius: 24px !important;
}
.delete-meeting-title {
  font-weight: bold;
  font-size: 20px;
  color: white;
}

.delete-meeting-content {
  font-size: 14px;
  color: #96a7af;
}
.container-btn >>> .v-btn * {
  font-size: 14px;
  color: white;
  letter-spacing: 0;
  text-transform: none;
  font-weight: bold;
}
</style>
